module.exports = __webpack_public_path__ + "img/iriomote_4.253ba383.jpg";